import { Flex, Text, Tooltip } from '@byecode/ui'
import { type NodeOption, nodeTypeIconMap, nodeTypeIconPlatformMap } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import * as SC from './styles'

type Props = {
    item: NodeOption
    onClick?: React.MouseEventHandler<HTMLDivElement>
    icon?: string
}

const TooltipComponent: React.FC<Props> = ({ item, icon }) => {
    return (
        <SC.TooltipContainer>
            <Flex alignItems="center" style={{ height: '34px' }}>
                <SC.ItemIconOuter background={item?.background}>
                    <SC.Icon type={icon as string} size={14} color={item?.color} />
                </SC.ItemIconOuter>
                <Text color="var(--color-gray-900)" ml={8}>
                    {item.label}
                </Text>
            </Flex>
            <SC.TooltipDesc>{item.desc}</SC.TooltipDesc>
        </SC.TooltipContainer>
    )
}

const TooltipStyle = {
    background: 'var(--color-white)',
    padding: '8px 0',
    width: '268px',
    boxShadow: '0px 4px 12px 0px #1018281A',
    borderRadius: '8px'
}

const SelectItem = ({ item, onClick }: Props) => {
    const icon = useMemo(() => {
        if (item.subType) {
            return nodeTypeIconPlatformMap[item.subType]
        }
        return nodeTypeIconMap[item.value]
    }, [item])

    return (
        <Tooltip title={<TooltipComponent icon={icon} item={item} />} placement="right" styles={TooltipStyle}>
            <SC.SelectItem onClick={onClick}>
                <Flex alignItems="center" style={{ height: '36px' }}>
                    <SC.ItemIconOuter background={item?.background}>
                        <SC.Icon type={icon} size={14} color={item?.color} />
                    </SC.ItemIconOuter>
                    <SC.SelectItemTitle>{item.label}</SC.SelectItemTitle>
                </Flex>
            </SC.SelectItem>
        </Tooltip>
    )
}

export default SelectItem
